import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import crmservices from '../../wsclient/crmservices';
import PromotionDetailView from './PromotionDetailView';
const styles = theme => ({

});
function PromotionDetail(props) {
    return (
        <div>
            <PromotionDetailView
                    showLoading = {false}
                    offer={props.offer}
                    onCloseOfferDetail={props.onCloseOfferDetail}
                    open={props.open}
                    onClose = {props.onClose}/>
        </div>
    );
}

export default withStyles(styles)(withTranslation()(PromotionDetail));